// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-nav-links:hover {
  color: white;
}

.inner-nav-link {
  padding: 0.4rem 1rem;
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 0.5rem;
  transition: 0.15s;
}

/* .admin-nav-links:hover .inner-nav-link {
  background-color: rgba(134, 188, 34, 0.3);
  color: white;
  border-radius: 4px;
} */

.admin-sub-links {
  padding: 4px 0 4px 53px;
  display: flex;
  align-items: center;
  font-size: 13px;
}

.admin-links-active {
  /* background-color: rgba(134, 188, 34, 0.3) !important; */
  border-left: rgba(134, 188, 34) solid 3px;
}

.sidebar-container {
  position: relative;
  width: 78px;
  height: 100vh;
  /* transition: all 0.5s ease; */
}

.sidebar-container.open {
  width: 275px !important;
}

.sidebar {
  position: relative;
  left: 0;
  top: 60;
  height: 100%;
  width: 78px;
  background: black;
  padding: 6px 14px;
  z-index: 99;
  height: 100vh;
  /* transition: all 0.5s ease; */
}
.sidebar.open {
  width: 275px;
}
.sidebar .logo-details {
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
  white-space: nowrap;
}
.sidebar .logo-details .icon {
  opacity: 0;
  /* transition: all 0.5s ease; */
}
.sidebar .logo-details .logo_icon {
  opacity: 0;
  height: unset;
  min-width: 40px;
}
.sidebar.open .logo-details .logo_icon {
  opacity: 1;
}
.sidebar .logo-details .logo_name {
  color: #fff;
  font-size: 18px;
  font-weight: 200;
  opacity: 0;
  margin-top: 4px;
  /* transition: all 0.4s ease; */
  /* padding-left: 20px; */
}
.sidebar.open .logo-details .icon,
.sidebar.open .logo-details .logo_name {
  opacity: 1;
}
.sidebar .logo-details #btn {
  position: absolute;
  top: 54%;
  right: 0;
  transform: translateY(-50%);
  font-size: 22px;
  /* transition: all 0.4s ease; */
  font-size: 23px;
  text-align: center;
  cursor: pointer;
  border-radius: 50%;
  transition: all 0.5s ease;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sidebar.open .logo-details #btn {
  text-align: right;
}
.sidebar .logo-details #btn:hover {
  background-color: rgba(134, 188, 34, 0.3);
}
.sidebar i {
  color: #fff;
  height: 50px;
  min-width: 50px;
  font-size: 28px;
  text-align: center;
  line-height: 60px;
}
.sidebar .nav-list {
  margin-top: 10px;
  height: 100%;
  padding-left: 0;
}
.sidebar li {
  position: relative;
  margin: 8px 0;
  list-style: none;
}
.sidebar li .tooltip {
  position: absolute;
  top: -20px;
  left: calc(100% + 15px);
  z-index: 3;
  background: #fff;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  opacity: 0;
  white-space: nowrap;
  pointer-events: none;
  transition: 0s;
}
.sidebar li:hover .tooltip {
  opacity: 1;
  pointer-events: auto;
  transition: all 0.4s ease;
  top: 50%;
  transform: translateY(-50%);
}
.sidebar.open li .tooltip {
  display: none;
}
.sidebar .logo-details .tooltip {
  position: absolute;
  top: -20px;
  left: calc(100% + 15px);
  z-index: 3;
  background: #fff;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 400;
  opacity: 0;
  white-space: nowrap;
  pointer-events: none;
  transition: 0s;
}
.sidebar .logo-details:hover .tooltip {
  opacity: 1;
  pointer-events: auto;
  transition: all 0.4s ease;
  top: 50%;
  transform: translateY(-50%);
}
.sidebar.open .logo-details .tooltip {
  display: none;
}
.sidebar input {
  font-size: 15px;
  color: #fff;
  font-weight: 400;
  outline: none;
  height: 50px;
  width: 100%;
  width: 50px;
  border: none;
  border-radius: 12px;
  /* transition: all 0.5s ease; */
  background: black;
}
.sidebar.open input {
  padding: 0 20px 0 50px;
  width: 100%;
}
.sidebar li a {
  display: flex;
  height: 100%;
  width: 100%;
  /* border-radius: 12px; */
  align-items: center;
  text-decoration: none;
  /* transition: all 0.3s ease; */
  background: black;
}
.sidebar li a:hover {
  background: rgba(134, 188, 34, 0.3);
  /* border-radius: 12px; */
}
.sidebar li a .links_name {
  color: #fff;
  font-size: 15px;
  font-weight: 400;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  /* transition: 0.4s; */
}
.sidebar.open li a .links_name {
  opacity: 1;
  pointer-events: auto;
}
.sidebar li a:hover .links_name,
.sidebar li a:hover i {
  /* transition: all 0.5s ease; */
  
}
.sidebar li a .links_notifications {
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  color: #fff;
  font-size: 10.5px;
  font-weight: 400;
  white-space: nowrap;
  opacity: 1;
  position: absolute;
  pointer-events: none;
  /* transition: 0.4s ease-in-out; */
  right: 6px;
  bottom: 46%;
  background-color: rgba(134, 188, 34, 0.8);
  padding: 2px 4px 2px 4px;
  min-width: 20px;
  min-height: 20px;
  text-align: center;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.sidebar.open li a .links_notifications {
  opacity: 1;
  right: 10px;
  bottom: unset;
  font-size: 12.5px;
  pointer-events: auto;
  padding: 3px 3px 3px 4px;
  /* font-weight: normal; */
  min-width: 25px;
  background-color: rgba(134, 188, 34, 0.65);
}
.sidebar.open li .sub-menu-icon {
  border-radius: 50%;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  color: #fff;
  font-size: 10.5px;
  font-weight: 400;
  white-space: nowrap;
  opacity: 1;
  position: absolute;
  pointer-events: none;
  /* transition: 0.4s ease-in-out; */
  right: 6px;
  /* bottom: 46%; */
  padding: 2px 5px 2px 4px;
  min-width: 20px;
  min-height: 20px;
  text-align: center;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}
.sidebar.open li .sub-menu-icon:hover {
  background-color: red;
  cursor: pointer;
}
.sidebar li i {
  height: 50px;
  line-height: 50px;
  font-size: 18px;
  border-radius: 12px;
}

@media (max-width: 420px) {
  .sidebar li .tooltip {
    display: none;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/AdminNavBar/AdminNavBar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;GAIG;;AAEH;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0DAA0D;EAC1D,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,OAAO;EACP,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,aAAa;EACb,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,UAAU;EACV,aAAa;EACb,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,+BAA+B;EAC/B,wBAAwB;AAC1B;AACA;;EAEE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,UAAU;EACV,oBAAoB;EACpB,yBAAyB;EACzB,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;;EAEE,+BAA+B;;AAEjC;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,UAAU;EACV,WAAW;EACX,yCAAyC;EACzC,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;EAC1B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,UAAU;EACV,iBAAiB;EACjB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".admin-nav-links:hover {\n  color: white;\n}\n\n.inner-nav-link {\n  padding: 0.4rem 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  gap: 0.5rem;\n  transition: 0.15s;\n}\n\n/* .admin-nav-links:hover .inner-nav-link {\n  background-color: rgba(134, 188, 34, 0.3);\n  color: white;\n  border-radius: 4px;\n} */\n\n.admin-sub-links {\n  padding: 4px 0 4px 53px;\n  display: flex;\n  align-items: center;\n  font-size: 13px;\n}\n\n.admin-links-active {\n  /* background-color: rgba(134, 188, 34, 0.3) !important; */\n  border-left: rgba(134, 188, 34) solid 3px;\n}\n\n.sidebar-container {\n  position: relative;\n  width: 78px;\n  height: 100vh;\n  /* transition: all 0.5s ease; */\n}\n\n.sidebar-container.open {\n  width: 275px !important;\n}\n\n.sidebar {\n  position: relative;\n  left: 0;\n  top: 60;\n  height: 100%;\n  width: 78px;\n  background: black;\n  padding: 6px 14px;\n  z-index: 99;\n  height: 100vh;\n  /* transition: all 0.5s ease; */\n}\n.sidebar.open {\n  width: 275px;\n}\n.sidebar .logo-details {\n  height: 60px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  white-space: nowrap;\n}\n.sidebar .logo-details .icon {\n  opacity: 0;\n  /* transition: all 0.5s ease; */\n}\n.sidebar .logo-details .logo_icon {\n  opacity: 0;\n  height: unset;\n  min-width: 40px;\n}\n.sidebar.open .logo-details .logo_icon {\n  opacity: 1;\n}\n.sidebar .logo-details .logo_name {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 200;\n  opacity: 0;\n  margin-top: 4px;\n  /* transition: all 0.4s ease; */\n  /* padding-left: 20px; */\n}\n.sidebar.open .logo-details .icon,\n.sidebar.open .logo-details .logo_name {\n  opacity: 1;\n}\n.sidebar .logo-details #btn {\n  position: absolute;\n  top: 54%;\n  right: 0;\n  transform: translateY(-50%);\n  font-size: 22px;\n  /* transition: all 0.4s ease; */\n  font-size: 23px;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 50%;\n  transition: all 0.5s ease;\n  transition: background-color 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.sidebar.open .logo-details #btn {\n  text-align: right;\n}\n.sidebar .logo-details #btn:hover {\n  background-color: rgba(134, 188, 34, 0.3);\n}\n.sidebar i {\n  color: #fff;\n  height: 50px;\n  min-width: 50px;\n  font-size: 28px;\n  text-align: center;\n  line-height: 60px;\n}\n.sidebar .nav-list {\n  margin-top: 10px;\n  height: 100%;\n  padding-left: 0;\n}\n.sidebar li {\n  position: relative;\n  margin: 8px 0;\n  list-style: none;\n}\n.sidebar li .tooltip {\n  position: absolute;\n  top: -20px;\n  left: calc(100% + 15px);\n  z-index: 3;\n  background: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 15px;\n  font-weight: 400;\n  opacity: 0;\n  white-space: nowrap;\n  pointer-events: none;\n  transition: 0s;\n}\n.sidebar li:hover .tooltip {\n  opacity: 1;\n  pointer-events: auto;\n  transition: all 0.4s ease;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.sidebar.open li .tooltip {\n  display: none;\n}\n.sidebar .logo-details .tooltip {\n  position: absolute;\n  top: -20px;\n  left: calc(100% + 15px);\n  z-index: 3;\n  background: #fff;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);\n  padding: 6px 12px;\n  border-radius: 4px;\n  font-size: 15px;\n  font-weight: 400;\n  opacity: 0;\n  white-space: nowrap;\n  pointer-events: none;\n  transition: 0s;\n}\n.sidebar .logo-details:hover .tooltip {\n  opacity: 1;\n  pointer-events: auto;\n  transition: all 0.4s ease;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.sidebar.open .logo-details .tooltip {\n  display: none;\n}\n.sidebar input {\n  font-size: 15px;\n  color: #fff;\n  font-weight: 400;\n  outline: none;\n  height: 50px;\n  width: 100%;\n  width: 50px;\n  border: none;\n  border-radius: 12px;\n  /* transition: all 0.5s ease; */\n  background: black;\n}\n.sidebar.open input {\n  padding: 0 20px 0 50px;\n  width: 100%;\n}\n.sidebar li a {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  /* border-radius: 12px; */\n  align-items: center;\n  text-decoration: none;\n  /* transition: all 0.3s ease; */\n  background: black;\n}\n.sidebar li a:hover {\n  background: rgba(134, 188, 34, 0.3);\n  /* border-radius: 12px; */\n}\n.sidebar li a .links_name {\n  color: #fff;\n  font-size: 15px;\n  font-weight: 400;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  /* transition: 0.4s; */\n}\n.sidebar.open li a .links_name {\n  opacity: 1;\n  pointer-events: auto;\n}\n.sidebar li a:hover .links_name,\n.sidebar li a:hover i {\n  /* transition: all 0.5s ease; */\n  \n}\n.sidebar li a .links_notifications {\n  border-radius: 50%;\n  -moz-border-radius: 50%;\n  -webkit-border-radius: 50%;\n  color: #fff;\n  font-size: 10.5px;\n  font-weight: 400;\n  white-space: nowrap;\n  opacity: 1;\n  position: absolute;\n  pointer-events: none;\n  /* transition: 0.4s ease-in-out; */\n  right: 6px;\n  bottom: 46%;\n  background-color: rgba(134, 188, 34, 0.8);\n  padding: 2px 4px 2px 4px;\n  min-width: 20px;\n  min-height: 20px;\n  text-align: center;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n}\n.sidebar.open li a .links_notifications {\n  opacity: 1;\n  right: 10px;\n  bottom: unset;\n  font-size: 12.5px;\n  pointer-events: auto;\n  padding: 3px 3px 3px 4px;\n  /* font-weight: normal; */\n  min-width: 25px;\n  background-color: rgba(134, 188, 34, 0.65);\n}\n.sidebar.open li .sub-menu-icon {\n  border-radius: 50%;\n  -moz-border-radius: 50%;\n  -webkit-border-radius: 50%;\n  color: #fff;\n  font-size: 10.5px;\n  font-weight: 400;\n  white-space: nowrap;\n  opacity: 1;\n  position: absolute;\n  pointer-events: none;\n  /* transition: 0.4s ease-in-out; */\n  right: 6px;\n  /* bottom: 46%; */\n  padding: 2px 5px 2px 4px;\n  min-width: 20px;\n  min-height: 20px;\n  text-align: center;\n  width: fit-content;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n.sidebar.open li .sub-menu-icon:hover {\n  background-color: red;\n  cursor: pointer;\n}\n.sidebar li i {\n  height: 50px;\n  line-height: 50px;\n  font-size: 18px;\n  border-radius: 12px;\n}\n\n@media (max-width: 420px) {\n  .sidebar li .tooltip {\n    display: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
